export default function(x) {
  return function() {
    return x;
  };
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-interpolate/src/constant.js